module.exports = __webpack_public_path__ + "assets/img/box2.c67fbdb3.png";